(() => {
  const catalogs = document.querySelectorAll('[data-sl-archive-catalog]');
  if (!catalogs.length) return;

  catalogs.forEach((catalog) => {
    const chips = catalog.querySelectorAll('.slac__chip');
    const cards = catalog.querySelectorAll('[data-slac-card]');
    const currentPath = window.location.pathname.replace(/\/$/, '');

    chips.forEach((chip) => {
      const chipPath = new URL(chip.href, window.location.origin).pathname.replace(/\/$/, '');
      if (chipPath === currentPath) chip.classList.add('is-active');
    });

    const setParallax = () => {
      const rect = catalog.getBoundingClientRect();
      const visibleOffset = Math.max(-rect.top, 0);
      catalog.style.setProperty('--slac-scroll', `${Math.min(visibleOffset, 900)}px`);
    };

    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        setParallax();
        raf = null;
      });
    };

    const onPointer = (event) => {
      const rect = catalog.getBoundingClientRect();
      const x = event.clientX - rect.left - rect.width / 2;
      catalog.style.setProperty('--slac-mx', `${Math.max(Math.min(x / 32, 18), -18)}px`);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    catalog.addEventListener('pointermove', onPointer, { passive: true });
    setParallax();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

      cards.forEach((card) => observer.observe(card));
      return;
    }

    cards.forEach((card) => card.classList.add('is-visible'));
  });
})();